













































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';
import MainLayout from '@/layouts/Main.vue';
import { Lang } from '@/lang/en/info.ts';
import Validation from '@/services/validation';
import LocationsService from '@/services/locations';
import LocationTypesService from '@/services/location-types';
import CoursesService from '@/services/courses';
import CategoriesService from '@/services/categories';
import ConfirmationDialog from '@/components/form/ConfirmationDialog.vue';
import ShopsService from '@/services/shops';

@Component({
  components: {
    MainLayout,
    ConfirmationDialog,
  },
})
export default class Info extends Vue {
  private lang: any = Lang;
  private mutableLocation: any = {};
  private clonedLocationTypes: any = [];
  private clonedCourses: any = [];
  private clonedCategories: any = [];
  private clonedShops: any = [];
  private loading: boolean = false;
  private payload: any = {};
  private valid: boolean = false;
  private locationLoaded: boolean = false;
  private dialog: boolean = false;

  private nameRules: object[] = [
    (v) => !!v || this.lang.form.validation.name.required,
    (v) => (v && v.length < 50) || this.lang.form.validation.name.length,
  ];

  private lngRules: object[] = [
    (v) => !!v ||  this.lang.form.validation.longitude.required,
    (v) => (v && Validation.coordinatesValidation(v)) || this.lang.form.validation.longitude.regex,
  ];

  private latRules: object[] = [
    (v) => !!v || this.lang.form.validation.latitude.required,
    (v) => (v && Validation.coordinatesValidation(v)) || this.lang.form.validation.latitude.regex,
  ];

  private categoryRules: object[] = [
    (v) => !!v[0] || this.lang.form.validation.category.required,
  ];

  private locationTypesRules: object[] = [
    (v) => !!v || this.lang.form.validation.type.required,
  ];

  private beforeCreate() {
    LocationTypesService.Get();
    CoursesService.Get();
    CategoriesService.Get();
    ShopsService.Get();
    LocationsService.Show((this.$route.params as any).id);
  }

  private submit() {
    if (this.valid) {
      try {
        this.payload = {...this.mutableLocation};
        LocationsService.Update(this.payload);
      } catch (e) {
        return false;
      }
    }
  }

  private showDialog() {
    this.dialog = true;
  }

  private destroy() {
    try {
      LocationsService.Delete((this.$route.params as any).id);
    } catch (e) {
      return false;
    }
  }

  private close() {
    this.dialog = false;
  }

  get location() {
    return store.getters['Locations/currentLocation'];
  }

  get locationTypes() {
    return store.getters['LocationTypes/getLocationTypes'];
  }

  get courses() {
    return store.getters['Courses/getCourses'];
  }

  get categories() {
    return store.getters['Categories/getCategories'];
  }

  get shops() {
    return store.getters['Shops/getShops'];
  }

  private cancel() {
    this.$router.push({ name: 'locations' });
  }

  @Watch('location')
  private onChange(newVal) {
    this.mutableLocation = {...this.location};
    this.locationLoaded = true;
  }

  @Watch('locationTypes')
  private onLocationTypesChange(newVal) {
    this.clonedLocationTypes = this.locationTypes;
  }

  @Watch('courses')
  private onCoursesChange(newVal) {
    this.clonedCourses = this.courses;
  }

  @Watch('categories')
  private onCategoriesChange(newVal) {
    this.clonedCategories = this.categories;
  }

  @Watch('shops')
  private onShopsChange(newVal) {
    this.clonedShops = this.shops;
  }
}
